import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import store from '@/store'

//引入其它子路由，记得在前面加上三点...
import baseInfo from './baseInfo'

import sys from './sys'

import institute from './institute'
import product from './product'
import msg from './msg'
import statistics from './statistics'
import user from './user'
import order from './order'
import marketing from './marketing'
Vue.use(Router)

const router = new Router({
/*   mode: 'history',  */
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/Index'),
     // redirect: '/baseInfo/home',
      meta: {title: '主页'},
      children: [
        ...baseInfo,
        ...institute,
        ...product,
        ...msg,
        ...statistics,
        ...sys,
        ...user,
        ...order,
        ...marketing

      ]
    },
    {
        path: '/sys/themes',
        name: 'themes',
        component: () => import('@/views/sys/themes/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        anonymous: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.getters.getUserInfo()
  if (to.matched.length == 0) return next({ path: '/404' });
  //如果对象里hasOwnProperty检查包涵meta属性，并且为anonymous为真，或isLogin为真才可以进行下一页操作
  if ((to.hasOwnProperty('meta') && to.meta.anonymous) || store.getters.isLogin()) {
    return next();
  }
  //query产生一个随机数在 login->home->login执行不了
  next({ path: '/login', query: { redirect: Math.random() } });
})


router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log(error.message);
  console.log(targetPath);
  if (isChunkLoadFailed) {
    window.location.replace(window.location.href);
    //  router.replace(targetPath);
  }
});
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js